import React, { Component } from "react";
import { FormGroup, Radio, ControlLabel, Grid, Row, Col } from 'react-bootstrap';
import DatePicker from 'react-16-bootstrap-date-picker';
import Select from "react-select";
import { GenericSelectableTable } from "./GenericSelectableTable";

export class LineSelection extends Component {
    render() {
        return (
            <Grid className="margin-top-15" fluid>
                <FormGroup controlId="formLine">
                    <Row className="padding-top-7">
                        <Col sm={2} md={1}>
                            <ControlLabel className="padding-top-10">Layout</ControlLabel>
                        </Col>
                        <Col sm={5} md={5}>
                            <Select
                                className="custom-multiselect"
                                placeholder="Sem Layout selecionado"
                                noOptionsMessage={() => "Sem Layouts Configurados"}
                                onChange={(e) => this.props.onSelectValue(e, "layout")}
                                options={this.props.layouts.sort((a, b) => a.name.localeCompare(b.name))}  // ascending
                                isOptionSelected={(option, value) => {
                                    if (undefined === value) {
                                        return false;
                                    } 

                                    return option.id === value.id;
                                }}
                                isMulti={false}
                                isClearable={true}
                                getOptionValue={value => value}
                                getOptionLabel={label => label.name}
                                value={this.props.selectedLayout}
                            />
                        </Col>
                        <Col sm={5} md={4}>
                            <ControlLabel className="padding-top-10 margin-right-15">Tipologia dos Pontos</ControlLabel>
                        </Col>
                    </Row>
                    <Row className="padding-top-7">
                        <Col sm={2} md={1}>
                            <ControlLabel className="padding-top-10">Data de Referência</ControlLabel>
                        </Col>
                        <Col sm={5} md={5}>
                            <DatePicker
                                id="referenceDateDatePicker"
                                dateFormat="DD/MM/YYYY"
                                value={this.props.referenceDate}
                                placeholder="Data de Referência"
                                onChange={(e) => this.props.onChangeReferenceDateChange(e)} />
                        </Col>
                        <Col sm={5} md={4}>
                            <Radio key={1}
                                className="margin-left-15 blue-radio-button"
                                checked={this.props.pointType === 0}
                                onChange={() => this.props.onSelectValue(0, "pointType")}
                                inline >
                                Ponto Notável
                            </Radio>
                            &nbsp;&nbsp;&nbsp;&nbsp;
                            <Radio key={2}
                                className="no-margin-left blue-radio-button"
                                checked={this.props.pointType === 1}
                                onChange={() => this.props.onSelectValue(1, "pointType")}
                                inline >
                                Paragem
                            </Radio>
                        </Col>
                    </Row>
                    <Row className="padding-top-7">
                        <Col sm={2} md={1}>
                            <ControlLabel className="padding-top-10">Ponto Notável</ControlLabel>
                        </Col>
                        <Col sm={5} md={5}>
                            {this.props.mapPoints !== undefined && (
                                <Select
                                    className="custom-multiselect"
                                    placeholder="Sem Ponto Notável Selecionado"
                                    noOptionsMessage={() => "Sem Pontos Notáveis Configurados"}
                                    onChange={(e) => this.props.onSelectValue(e, "mapPoint")}
                                    options={this.props.mapPoints.sort((a, b) => a.name.localeCompare(b.name))}  // ascending
                                    isOptionSelected={(option, value) => {
                                        if (undefined === value) {
                                            return false;
                                        }

                                        return option.id === value.id;
                                    }}
                                    isMulti={false}
                                    isClearable={true}
                                    getOptionValue={value => value}
                                    getOptionLabel={label => label.name}
                                    value={this.props.selectedMapPoint}
                                />
                            )}
                        </Col>
                    </Row>

                    <Row className="margin-top-20">
                        <Col>
                            <div style={{ minHeight: '40px', marginTop: '16px', marginLeft: '16px', maxWidth:'950px', position: 'relative' }}>
                                <div style={{
                                    minHeight: '40px',
                                    marginTop: '16px',
                                    transition: 'min-height 0.2s',
                                    position: 'relative'
                                }}>
                                    {this.props.selectedLayout &&
                                        Array.isArray(this.props.selectedLayout.components) &&
                                        !this.props.selectedLayout.components.some(c => c.type === "SchematicMap") && (
                                            <div
                                                className="alert alert-warning"
                                                role="alert"
                                                style={{
                                                    marginTop: '8px',
                                                    marginBottom: 0,
                                                    position: 'absolute',
                                                    width: '100%',
                                                    left: 0,
                                                    zIndex: 1
                                                }}
                                            >
                                                <strong>Atenção:</strong> O layout selecionado não contém um componente para a geração de mapas esquemáticos.
                                            </div>
                                        )}
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row className="margin-top-30">
                        <GenericSelectableTable
                            data={this.props.lines}
                            onSearch={(filter) => this.props.onSearch(filter)}
                            onRowClick={(row) => this.props.onRowClick(row)}
                            isRowSelected={(row) => this.props.isRowSelected(row)}
                            renderCell={(row) => `${row.code} | ${row.goName}`}
                            onSelectAll={() => { this.props.onSelectAll() }}
                            sortableFields={[
                                { value: "code", label: "Código" },
                                { value: "goName", label: "Nome" },
                            ]}
                        />
                    </Row>
                </FormGroup>
            </Grid>
        );
    }
}